import React from 'react'
import PropTypes from 'prop-types'
import remarkGfm from 'remark-gfm'
import ReactMarkdown from 'react-markdown'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import FlexRow from '../../../../molecules/FlexRow'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'
import CodeTag from '../../../../atoms/CodeTag'
import Loading from '../../../../molecules/Loading'
import { abundanceDesigner } from './playgroundApp'

function ChatMessage ({ message, onJsxAttachmentClick }) {
  abundanceDesigner.useGenerationPolling(message)

  const { formatter } = useFormattingContext()

  if (!message) return null

  const classes = message.actor === 'user'
    ? 'bg-neutral-050 p-sm shadow-md text-contrast-neutral-050 radius-sm flex flex-col gap-sm'
    : 'p-sm radius-sm flex flex-col gap-sm'

  return (
    <div>
      <FlexRow className='justify-between' style={{ borderBottom: message?.actor === 'user' ? undefined : 'var(--border-neutral-thin)' }}>
        <span style={{ color: message?.actor === 'user' ? undefined : 'var(--color-ai-600)' }}>{message?.actor === 'user' ? 'You' : 'Abundance Designer'}</span>
        <span>{formatter(message?.createdDate, '&h:mm a')}</span>
      </FlexRow>
      <FadeIn className={classes}>
        {message.isGenerating ? (
          <FlexRow>
            <span><Loading size={16} /></span>
            <span>{message.generationStatus}</span>
          </FlexRow>
        ) : (
          <FadeIn style={{ fontWeight: 'var(--font-weight-thin)' }}>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
            >
              {message.message}
            </ReactMarkdown>
          </FadeIn>
        )}
        {(message.attachments || []).map((attachment) => (
          <div
            key={attachment.threadMessageAttachmentId}
            className='opal-surface-default opal-selectable radius-sm p-xs flex flex-row gap-sm items-center'
            style={{ borderColor: 'var(--color-ai-500)' }}
            onClick={() => onJsxAttachmentClick(attachment)}
          >
            <CodeTag>{attachment.contentType}</CodeTag>
            <span>{attachment.title}</span>
          </div>
        ))}
      </FadeIn>
    </div>
  )
}

ChatMessage.propTypes = {
  message: PropTypes.shape({
    threadId: PropTypes.string,
    threadMessageId: PropTypes.string,
    actor: PropTypes.oneOf(['agent', 'user']),
    message: PropTypes.string,
    data: PropTypes.object,
    isGenerating: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    generationStatus: PropTypes.string,
    responseId: PropTypes.string,
    createdDate: PropTypes.string,
    attachments: PropTypes.array
  }),
  onJsxAttachmentClick: PropTypes.func
}

export default ChatMessage
